import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import { withRouteAccessCheck } from "../../../../../app/Hoc/WithLoginAceessCheck.js";
import { deleteSubscriber } from "../../../../../app/redux/slices/app/manageFiberServiceSlice.js";
import ConfirmationDialog from "../../../../components/customComponents/ConfirmationModal/index";
import CustomSnackbar from "../../../../components/customComponents/CustomSnackbar/index";
import { validateForm } from "../../../../components/customComponents/customValidation/index";

import {
  searchAddr,
  getPremiseDetails,
  fetchONTdetailsBySlNumber,
  updatePremiseServicePointDetails,
  updatePremiseDetails,
  updateOrderDetails,
  updateCaseDetails,
} from "../../../../../app/redux/slices/app/fiberEnrollmentIssueSlice.js";
import { CircularProgress } from "@mui/material";
import { el } from "date-fns/locale";
import {
  getsignedCommunitiesList,
  deleteCommunity,
  addCommunity,
  updateExistingCommunity,
} from "../../../../../app/redux/slices/app/signedCommunities.js";

const AddCommunity = ({ onClose, editData, clear }) => {
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [showMessage, setShowMessage] = useState("");
  const [searchedAddreess, setSearchedAdrr] = useState([]);
  const [searchLoader, setSearchLoader] = useState(false);
  const [open, setOpen] = useState(false);
  const dispatch = useDispatch();
  const [dialogOpen, setDialogOpen] = useState(false);
  const [errorMessages, setErrorMessages] = useState({});
  const [wrongAddress, showPopupForWrongAddress] = useState(false);
  const [deviceNoInstalledPopup, showDeviceNoInstalledPopup] = useState(false);
  const [loader, setLoader] = useState(false);

  const initState = {
    name: "",
    projectName: "",
    unsignedJvPlaceholder: "",
    aliases: "",
    files: "",
    owner: "",
    developer: "",
    developerId: 0,
    projectId: "",
    franchiseStatus: "",
    memoRecorded: "",
    omtt: "",
    projectType: "",
    gasNumLots: 0,
    fiberNumLots: 0,
    gasFiberBoth: "",
    fiberAgreementStructure: "",
    bulkIndividualBill: "",
    hoaBulk: "",
    taa: "",
    jv: "",
    jvEntity: "",
    market: "",
    county: "",
    city: "",
    dateExecutedGas: "",
    dateExecutedFiber: "",
    solarHeadEnd: 0,
    gbpsPrice1: 0,
    lineService: "",
    estFirstCapexSpend: "",
    estFsnCoDate: "",
    comments: "",
    gasDollarPerLot: "",
    gasRoyaltyPercent: "",
    fiberDollarPerLot: "",
    fiberRoyaltyPercent: "",
    buyback: "",
    term: "",
    gasCashUpfront: "",
    fiberCashUpfront: "",
    cashUpfrontTotal: "",
    notify: "",
    status: "",
    state: "",
  };
  const [formData, setFormData] = useState(initState);
  const validationRules = {
    name: {
      required: true,
      name: "Name",
      minDigits: "2",
    },
    projectName: {
      required: true,
      name: "Project Name",
      minDigits: "3",
    },
    // unsignedJvPlaceholder: {
    //   required: true,
    //   name: "Unsigned Jv Placeholder",
    //   minDigits: "3",
    // },

    // aliases: {
    //   required: true,
    //   name: "Aliases",
    //   minDigits: "3",
    // },
    files: {
      required: true,
      name: "files",
      minDigits: "3",
    },
    owner: {
      required: true,
      name: "owner",
      minDigits: "3",
    },
    developer: {
      required: true,
      name: "developer",
      minDigits: "2",
    },
    developerId: {
      required: true,
      name: "developer id",
      minDigits: "1",
    },

    // projectId: {
    //   required: true,
    //   name: "projectId",
    //   minDigits: "3",
    // },
    // franchiseStatus: {
    //   required: true,
    //   name: "franchiseStatus",
    //   minDigits: "3",
    // },
    // notes: {
    //   required: true,
    //   name: "memo recorded",
    //   minDigits: "3",
    // },
    // gasLots: {
    //   required: true,
    //   name: "Gas Lots",
    //   minValue: 1,
    // },
    // fiberLots: {
    //   required: true,
    //   name: "fiber Lots",
    //   minValue: 1,
    // },
    // agreementType: {
    //   required: true,
    //   name: "Fiber Agreement Structure",
    //   minDigits: "2",
    // },
    // county: {
    //   required: true,
    //   name: "county",
    //   minDigits: "2",
    // },

    // city: {
    //   required: true,
    //   name: "city",
    //   minDigits: "2",
    // },

    // signedDate: {
    //   required: true,
    //   name: "signed Date",
    //   minDigits: "2",
    // },
    // effectiveDate: {
    //   required: true,
    //   name: "effective Date",
    //   minDigits: "2",
    // },
    // comments: {
    //   required: true,
    //   name: "comments",
    //   minDigits: "2",
    // },
    // gasPerLot: {
    //   required: true,
    //   name: "gasPerLot",
    //   minDigits: "1",
    // },
    // gasRoyaltyPercent: {
    //   required: true,
    //   name: "gasRoyaltyPercent",
    //   minValue: "1",
    // },
    // fiberPerLot: {
    //   required: true,
    //   name: "fiberPerLot",
    //   minDigits: "1",
    // },
    // fiberRoyaltyPercent: {
    //   required: true,
    //   name: "fiberRoyaltyPercent",
    //   minValue: "1",
    // },
    // buyback: {
    //   required: true,
    //   name: "buyback",
    //   minDigits: "1",
    // },
    // term: {
    //   required: true,
    //   name: "term",
    //   minDigits: "1",
    // },
    // gasCashUpfront: {
    //   required: true,
    //   name: "gasCashUpfront",
    //   minDigits: "1",
    // },
    // fiberCashUpfront: {
    //   required: true,
    //   name: "fiberCashUpfront",
    //   minDigits: "1",
    // },
    // cashUpfrontTotal: {
    //   required: true,
    //   name: "cashUpfrontTotal",
    //   minDigits: "1",
    // },
    // notify: {
    //   required: true,
    //   name: "notify",
    //   minDigits: "2",
    // },
    // status: {
    //   required: true,
    //   name: "status",
    //   minDigits: "2",
    // },
    // state: {
    //   required: true,
    //   name: "state",
    //   minDigits: "2",
    // },
  };

  const validateAndSubmit = async () => {
    let validationErrors = validateForm(formData, validationRules);
    setErrorMessages(validationErrors);
    let noerror = Object.keys(validationErrors)?.length === 0;
    if (noerror) {
      if (formData?.id) {
        updateCommunity();
      } else {
        addNewCommunity();
      }
    }
  };
  useEffect(() => {
    if (editData?.id) {
      setFormData(editData);
    }
  }, [editData]);
  const addNewCommunity = async () => {
    setLoader(true);
    const orderRes = await dispatch(addCommunity({ ...formData }));
    if (orderRes?.payload?.data?.id) {
      setShowMessage("Community created successfully");
      setOpenSnackbar(true);
      setLoader(false);
      setTimeout(() => {
        onClose();
      }, [1500]);
    } else {
      setShowMessage("Error: Something went wrong. Please try later");
      setOpenSnackbar(true);
      setLoader(false);
    }
  };
  const updateCommunity = async () => {
    setLoader(true);
    const orderRes = await dispatch(updateExistingCommunity({ ...formData }));
    if (orderRes?.payload?.data?.id) {
      setShowMessage("Community updated successfully");
      setOpenSnackbar(true);
      setLoader(false);
      setTimeout(() => {
        onClose();
      }, [1500]);
    } else {
      setShowMessage("Error: Something went wrong. Please try later");
      setOpenSnackbar(true);
      setLoader(false);
    }
  };
  useEffect(() => {
    if (clear) {
      clearform();
    }
  }, [clear]);
  const clearform = () => {
    setFormData({
      name: "",
      projectName: "",
      unsignedJvPlaceholder: "",
      aliases: "",
      files: "",
      owner: "",
      developer: "",
      developerId: 0,
      projectId: "",
      franchiseStatus: "",
      memoRecorded: "",
      omtt: "",
      projectType: "",
      gasNumLots: 0,
      fiberNumLots: 0,
      gasFiberBoth: "",
      fiberAgreementStructure: "",
      bulkIndividualBill: "",
      hoaBulk: "",
      taa: "",
      jv: "",
      jvEntity: "",
      market: "",
      county: "",
      city: "",
      dateExecutedGas: "",
      dateExecutedFiber: "",
      solarHeadEnd: 0,
      gbpsPrice1: 0,
      lineService: "",
      estFirstCapexSpend: "",
      estFsnCoDate: "",
      comments: "",
      gasDollarPerLot: "",
      gasRoyaltyPercent: "",
      fiberDollarPerLot: "",
      fiberRoyaltyPercent: "",
      buyback: "",
      term: "",
      gasCashUpfront: "",
      fiberCashUpfront: "",
      cashUpfrontTotal: "",
      notify: "",
      status: "",
      state: "",
    });
  };

  return (
    <>
      <CustomSnackbar
        openSnackbar={openSnackbar}
        severity={
          showMessage.includes("Failed") || showMessage.includes("Error")
            ? "error"
            : "success"
        }
        message={showMessage}
        autoHideDuration={3000}
        handleClose={() => setOpenSnackbar(false)}
      />
      <div className="row min-h-100">
        <div className="col-xxl-12">
          <div className="card card-custom  manage-fiber-service">
            <div className="card-body">
              <div className="row justify-content-center">
                <div className="col-lg-8">
                  <div>
                    {/* <div className="custom_title mb-3">
                      <h3 className="heading">Add Community</h3>
                    </div> */}
                    <div className="row ">
                      <div className="col-lg-4">
                        <div className="form-group">
                          <label for="">Name</label>
                          <input
                            type="text"
                            className="form-control"
                            value={formData.name}
                            onChange={(e) => {
                              setFormData({
                                ...formData,
                                name: e.target.value,
                              });
                            }}
                          />{" "}
                          <div style={{ fontSize: "small", color: "red" }}>
                            {errorMessages.name && (
                              <div style={{ fontSize: "small", color: "red" }}>
                                {" "}
                                {errorMessages.name}
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-4">
                        <div className="form-group">
                          <label for="">Project Name</label>
                          <input
                            type="text"
                            className="form-control"
                            value={formData.projectName}
                            onChange={(e) => {
                              setFormData({
                                ...formData,
                                projectName: e.target.value,
                              });
                            }}
                          />{" "}
                          <div style={{ fontSize: "small", color: "red" }}>
                            {errorMessages.projectName && (
                              <div style={{ fontSize: "small", color: "red" }}>
                                {" "}
                                {errorMessages.projectName}
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-4">
                        <div className="form-group">
                          <label for="">Unsigned JV Placeholder</label>
                          <input
                            type="text"
                            className="form-control"
                            value={formData.unsignedJvPlaceholder}
                            onChange={(e) => {
                              setFormData({
                                ...formData,
                                unsignedJvPlaceholder: e.target.value,
                              });
                            }}
                          />{" "}
                          <div style={{ fontSize: "small", color: "red" }}>
                            {errorMessages.unsignedJvPlaceholder && (
                              <div style={{ fontSize: "small", color: "red" }}>
                                {" "}
                                {errorMessages.unsignedJvPlaceholder}
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="row ">
                      <div className="col-lg-4">
                        <div className="form-group">
                          <label for="">Aliases</label>
                          <input
                            type="text"
                            className="form-control"
                            value={formData.aliases}
                            onChange={(e) => {
                              setFormData({
                                ...formData,
                                aliases: e.target.value,
                              });
                            }}
                          />{" "}
                          <div style={{ fontSize: "small", color: "red" }}>
                            {errorMessages.aliases && (
                              <div style={{ fontSize: "small", color: "red" }}>
                                {" "}
                                {errorMessages.aliases}
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-4">
                        <div className="form-group">
                          <label for="">Files</label>
                          <input
                            type="text"
                            className="form-control"
                            value={formData.files}
                            onChange={(e) => {
                              setFormData({
                                ...formData,
                                files: e.target.value,
                              });
                            }}
                          />{" "}
                          <div style={{ fontSize: "small", color: "red" }}>
                            {errorMessages.files && (
                              <div style={{ fontSize: "small", color: "red" }}>
                                {" "}
                                {errorMessages.files}
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-4">
                        <div className="form-group">
                          <label for="">Owner</label>
                          <input
                            type="text"
                            className="form-control"
                            value={formData.owner}
                            onChange={(e) => {
                              setFormData({
                                ...formData,
                                owner: e.target.value,
                              });
                            }}
                          />{" "}
                          <div style={{ fontSize: "small", color: "red" }}>
                            {errorMessages.owner && (
                              <div style={{ fontSize: "small", color: "red" }}>
                                {" "}
                                {errorMessages.owner}
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="row ">
                      <div className="col-lg-4">
                        <div className="form-group">
                          <label for="">Developer</label>
                          <input
                            type="text"
                            className="form-control"
                            value={formData.developer}
                            onChange={(e) => {
                              setFormData({
                                ...formData,
                                developer: e.target.value,
                              });
                            }}
                          />{" "}
                          <div style={{ fontSize: "small", color: "red" }}>
                            {errorMessages.developer && (
                              <div style={{ fontSize: "small", color: "red" }}>
                                {" "}
                                {errorMessages.developer}
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-4">
                        <div className="form-group">
                          <label for="">Developer ID</label>
                          <input
                            type="number"
                            className="form-control"
                            value={formData.developerId}
                            onChange={(e) => {
                              setFormData({
                                ...formData,
                                developerId: e.target.value,
                              });
                            }}
                          />{" "}
                          <div style={{ fontSize: "small", color: "red" }}>
                            {errorMessages.developerId && (
                              <div style={{ fontSize: "small", color: "red" }}>
                                {" "}
                                {errorMessages.developerId}
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-4">
                        <div className="form-group">
                          <label for="">Project ID</label>
                          <input
                            type="text"
                            className="form-control"
                            value={formData.projectId}
                            onChange={(e) => {
                              setFormData({
                                ...formData,
                                projectId: e.target.value,
                              });
                            }}
                          />{" "}
                          <div style={{ fontSize: "small", color: "red" }}>
                            {errorMessages.projectId && (
                              <div style={{ fontSize: "small", color: "red" }}>
                                {" "}
                                {errorMessages.projectId}
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="row ">
                      <div className="col-lg-4">
                        <div className="form-group">
                          <label for="">Franchise Status</label>
                          <input
                            type="text"
                            className="form-control"
                            value={formData.franchiseStatus}
                            onChange={(e) => {
                              setFormData({
                                ...formData,
                                franchiseStatus: e.target.value,
                              });
                            }}
                          />{" "}
                          <div style={{ fontSize: "small", color: "red" }}>
                            {errorMessages.franchiseStatus && (
                              <div style={{ fontSize: "small", color: "red" }}>
                                {" "}
                                {errorMessages.franchiseStatus}
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-4">
                        <div className="form-group">
                          <label for="">Memo Recorded?</label>
                          <input
                            type="text"
                            className="form-control"
                            value={formData.notes}
                            onChange={(e) => {
                              setFormData({
                                ...formData,
                                notes: e.target.value,
                              });
                            }}
                          />{" "}
                          <div style={{ fontSize: "small", color: "red" }}>
                            {errorMessages.notes && (
                              <div style={{ fontSize: "small", color: "red" }}>
                                {" "}
                                {errorMessages.notes}
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-4">
                        <div className="form-group">
                          <label for="">OMTT</label>
                          <input
                            type="text"
                            className="form-control"
                            value={formData.omtt}
                            onChange={(e) => {
                              setFormData({
                                ...formData,
                                omtt: e.target.value,
                              });
                            }}
                          />{" "}
                          <div style={{ fontSize: "small", color: "red" }}>
                            {errorMessages.omtt && (
                              <div style={{ fontSize: "small", color: "red" }}>
                                {" "}
                                {errorMessages.omtt}
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="row ">
                      <div className="col-lg-4">
                        <div className="form-group">
                          <label for="">Project Type</label>
                          <input
                            type="text"
                            className="form-control"
                            value={formData.projectType}
                            onChange={(e) => {
                              setFormData({
                                ...formData,
                                projectType: e.target.value,
                              });
                            }}
                          />{" "}
                          <div style={{ fontSize: "small", color: "red" }}>
                            {errorMessages.projectType && (
                              <div style={{ fontSize: "small", color: "red" }}>
                                {" "}
                                {errorMessages.projectType}
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-4">
                        <div className="form-group">
                          <label for="">Gas # Lots</label>
                          <input
                            type="number"
                            className="form-control"
                            value={formData.gasLots}
                            onChange={(e) => {
                              setFormData({
                                ...formData,
                                gasLots: e.target.value,
                              });
                            }}
                          />{" "}
                          <div style={{ fontSize: "small", color: "red" }}>
                            {errorMessages.gasLots && (
                              <div style={{ fontSize: "small", color: "red" }}>
                                {" "}
                                {errorMessages.gasLots}
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-4">
                        <div className="form-group">
                          <label for="">Fiber # Lots</label>
                          <input
                            type="number"
                            className="form-control"
                            value={formData.fiberLots}
                            onChange={(e) => {
                              setFormData({
                                ...formData,
                                fiberLots: e.target.value,
                              });
                            }}
                          />{" "}
                          <div style={{ fontSize: "small", color: "red" }}>
                            {errorMessages.fiberLots && (
                              <div style={{ fontSize: "small", color: "red" }}>
                                {" "}
                                {errorMessages.fiberLots}
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="row ">
                      <div className="col-lg-4">
                        <div className="form-group">
                          <label for="">Gas/Fiber/Both</label>
                          <input
                            type="text"
                            className="form-control"
                            value={formData.gasFiberBoth}
                            onChange={(e) => {
                              setFormData({
                                ...formData,
                                gasFiberBoth: e.target.value,
                              });
                            }}
                          />{" "}
                          <div style={{ fontSize: "small", color: "red" }}>
                            {errorMessages.gasFiberBoth && (
                              <div style={{ fontSize: "small", color: "red" }}>
                                {" "}
                                {errorMessages.gasFiberBoth}
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-4">
                        <div className="form-group">
                          <label for="">Fiber Agreement Structure</label>
                          <input
                            type="text"
                            className="form-control"
                            value={formData.agreementType}
                            onChange={(e) => {
                              setFormData({
                                ...formData,
                                agreementType: e.target.value,
                              });
                            }}
                          />{" "}
                          <div style={{ fontSize: "small", color: "red" }}>
                            {errorMessages.agreementType && (
                              <div style={{ fontSize: "small", color: "red" }}>
                                {" "}
                                {errorMessages.agreementType}
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-4">
                        <div className="form-group">
                          <label for="">Bulk/Individual Bill</label>
                          <input
                            type="text"
                            className="form-control"
                            value={formData.bulkIndividualBill}
                            onChange={(e) => {
                              setFormData({
                                ...formData,
                                bulkIndividualBill: e.target.value,
                              });
                            }}
                          />{" "}
                          <div style={{ fontSize: "small", color: "red" }}>
                            {errorMessages.bulkIndividualBill && (
                              <div style={{ fontSize: "small", color: "red" }}>
                                {" "}
                                {errorMessages.bulkIndividualBill}
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="row ">
                      <div className="col-lg-4">
                        <div className="form-group">
                          <label for="">HOA/Bulk</label>
                          <input
                            type="text"
                            className="form-control"
                            value={formData.hoaBulk}
                            onChange={(e) => {
                              setFormData({
                                ...formData,
                                hoaBulk: e.target.value,
                              });
                            }}
                          />{" "}
                          <div style={{ fontSize: "small", color: "red" }}>
                            {errorMessages.hoaBulk && (
                              <div style={{ fontSize: "small", color: "red" }}>
                                {" "}
                                {errorMessages.hoaBulk}
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-4">
                        <div className="form-group">
                          <label for="">TAA</label>
                          <input
                            type="text"
                            className="form-control"
                            value={formData.taa}
                            onChange={(e) => {
                              setFormData({
                                ...formData,
                                taa: e.target.value,
                              });
                            }}
                          />{" "}
                          <div style={{ fontSize: "small", color: "red" }}>
                            {errorMessages.taa && (
                              <div style={{ fontSize: "small", color: "red" }}>
                                {" "}
                                {errorMessages.taa}
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-4">
                        <div className="form-group">
                          <label for="">JV</label>
                          <input
                            type="text"
                            className="form-control"
                            value={formData.jv}
                            onChange={(e) => {
                              setFormData({
                                ...formData,
                                jv: e.target.value,
                              });
                            }}
                          />{" "}
                          <div style={{ fontSize: "small", color: "red" }}>
                            {errorMessages.jv && (
                              <div style={{ fontSize: "small", color: "red" }}>
                                {" "}
                                {errorMessages.jv}
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="row ">
                      <div className="col-lg-4">
                        <div className="form-group">
                          <label for="">JV Entity</label>
                          <input
                            type="text"
                            className="form-control"
                            value={formData.jvEntity}
                            onChange={(e) => {
                              setFormData({
                                ...formData,
                                jvEntity: e.target.value,
                              });
                            }}
                          />{" "}
                          <div style={{ fontSize: "small", color: "red" }}>
                            {errorMessages.jvEntity && (
                              <div style={{ fontSize: "small", color: "red" }}>
                                {" "}
                                {errorMessages.jvEntity}
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-4">
                        <div className="form-group">
                          <label for="">Market</label>
                          <input
                            type="text"
                            className="form-control"
                            value={formData.market}
                            onChange={(e) => {
                              setFormData({
                                ...formData,
                                market: e.target.value,
                              });
                            }}
                          />{" "}
                          <div style={{ fontSize: "small", color: "red" }}>
                            {errorMessages.market && (
                              <div style={{ fontSize: "small", color: "red" }}>
                                {" "}
                                {errorMessages.market}
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-4">
                        <div className="form-group">
                          <label for="">County</label>
                          <input
                            type="text"
                            className="form-control"
                            value={formData.county}
                            onChange={(e) => {
                              setFormData({
                                ...formData,
                                county: e.target.value,
                              });
                            }}
                          />{" "}
                          <div style={{ fontSize: "small", color: "red" }}>
                            {errorMessages.county && (
                              <div style={{ fontSize: "small", color: "red" }}>
                                {" "}
                                {errorMessages.county}
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="row ">
                      <div className="col-lg-4">
                        <div className="form-group">
                          <label for="">City</label>
                          <input
                            type="text"
                            className="form-control"
                            value={formData.city}
                            onChange={(e) => {
                              setFormData({
                                ...formData,
                                city: e.target.value,
                              });
                            }}
                          />{" "}
                          <div style={{ fontSize: "small", color: "red" }}>
                            {errorMessages.city && (
                              <div style={{ fontSize: "small", color: "red" }}>
                                {" "}
                                {errorMessages.city}
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-4">
                        <div className="form-group">
                          <label for="">Date Executed Gas</label>
                          <input
                            type="date"
                            className="form-control"
                            value={formData.dateExecutedGas}
                            onChange={(e) => {
                              setFormData({
                                ...formData,
                                dateExecutedGas: e.target.value,
                              });
                            }}
                          />{" "}
                          <div style={{ fontSize: "small", color: "red" }}>
                            {errorMessages.dateExecutedGas && (
                              <div style={{ fontSize: "small", color: "red" }}>
                                {" "}
                                {errorMessages.dateExecutedGas}
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-4">
                        <div className="form-group">
                          <label for="">Date Executed Fiber</label>
                          <input
                            type="date"
                            className="form-control"
                            value={formData.dateExecutedFiber}
                            onChange={(e) => {
                              setFormData({
                                ...formData,
                                dateExecutedFiber: e.target.value,
                              });
                            }}
                          />{" "}
                          <div style={{ fontSize: "small", color: "red" }}>
                            {errorMessages.dateExecutedFiber && (
                              <div style={{ fontSize: "small", color: "red" }}>
                                {" "}
                                {errorMessages.dateExecutedFiber}
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="row ">
                      <div className="col-lg-4">
                        <div className="form-group">
                          <label for="">Solar Head End</label>
                          <input
                            type="text"
                            className="form-control"
                            value={formData.solarHeadEnd}
                            onChange={(e) => {
                              setFormData({
                                ...formData,
                                solarHeadEnd: e.target.value,
                              });
                            }}
                          />{" "}
                          <div style={{ fontSize: "small", color: "red" }}>
                            {errorMessages.solarHeadEnd && (
                              <div style={{ fontSize: "small", color: "red" }}>
                                {" "}
                                {errorMessages.solarHeadEnd}
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-4">
                        <div className="form-group">
                          <label for="">1 GBPS Price</label>
                          <input
                            type="text"
                            className="form-control"
                            value={formData.gbpsPrice1}
                            onChange={(e) => {
                              setFormData({
                                ...formData,
                                gbpsPrice1: e.target.value,
                              });
                            }}
                          />{" "}
                          <div style={{ fontSize: "small", color: "red" }}>
                            {errorMessages.gbpsPrice1 && (
                              <div style={{ fontSize: "small", color: "red" }}>
                                {" "}
                                {errorMessages.gbpsPrice1}
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-4">
                        <div className="form-group">
                          <label for="">Line Service</label>
                          <input
                            type="text"
                            className="form-control"
                            value={formData.lineService}
                            onChange={(e) => {
                              setFormData({
                                ...formData,
                                lineService: e.target.value,
                              });
                            }}
                          />{" "}
                          <div style={{ fontSize: "small", color: "red" }}>
                            {errorMessages.lineService && (
                              <div style={{ fontSize: "small", color: "red" }}>
                                {" "}
                                {errorMessages.lineService}
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="row ">
                      <div className="col-lg-4">
                        <div className="form-group">
                          <label for="">Est. First Capex Spend</label>
                          <input
                            type="date"
                            className="form-control"
                            value={formData.estFirstCapexSpend}
                            onChange={(e) => {
                              setFormData({
                                ...formData,
                                estFirstCapexSpend: e.target.value,
                              });
                            }}
                          />{" "}
                          <div style={{ fontSize: "small", color: "red" }}>
                            {errorMessages.estFirstCapexSpend && (
                              <div style={{ fontSize: "small", color: "red" }}>
                                {" "}
                                {errorMessages.estFirstCapexSpend}
                              </div>
                            )}
                          </div>
                        </div>
                        <div className="form-group">
                          <label for="">Est FSN/Co Date</label>
                          <input
                            type="date"
                            className="form-control"
                            value={formData.estFsnCoDate}
                            onChange={(e) => {
                              setFormData({
                                ...formData,
                                estFsnCoDate: e.target.value,
                              });
                            }}
                          />{" "}
                          <div style={{ fontSize: "small", color: "red" }}>
                            {errorMessages.estFsnCoDate && (
                              <div style={{ fontSize: "small", color: "red" }}>
                                {" "}
                                {errorMessages.estFsnCoDate}
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-8">
                        <div className="form-group h-100">
                          <label for="">Comment</label>
                          <textarea
                            className="form-control"
                            style={{ minHeight: "135px" }}
                            value={formData.comments}
                            onChange={(e) => {
                              setFormData({
                                ...formData,
                                comments: e.target.value,
                              });
                            }}
                          ></textarea>
                          <div style={{ fontSize: "small", color: "red" }}>
                            {errorMessages.comments && (
                              <div style={{ fontSize: "small", color: "red" }}>
                                {" "}
                                {errorMessages.comments}
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="row ">
                      <div className="col-lg-4">
                        <div className="form-group">
                          <label for="">Gas $/Lot</label>
                          <input
                            type="number"
                            className="form-control"
                            value={formData.gasPerLot}
                            onChange={(e) => {
                              setFormData({
                                ...formData,
                                gasPerLot: e.target.value,
                              });
                            }}
                          />{" "}
                          <div style={{ fontSize: "small", color: "red" }}>
                            {errorMessages.gasPerLot && (
                              <div style={{ fontSize: "small", color: "red" }}>
                                {" "}
                                {errorMessages.gasPerLot}
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-4">
                        <div className="form-group">
                          <label for="">Gas Royalty %</label>
                          <input
                            type="number"
                            className="form-control"
                            value={formData.gasRoyaltyPercent}
                            onChange={(e) => {
                              setFormData({
                                ...formData,
                                gasRoyaltyPercent: e.target.value,
                              });
                            }}
                          />{" "}
                          <div style={{ fontSize: "small", color: "red" }}>
                            {errorMessages.gasRoyaltyPercent && (
                              <div style={{ fontSize: "small", color: "red" }}>
                                {" "}
                                {errorMessages.gasRoyaltyPercent}
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-4">
                        <div className="form-group">
                          <label for="">Fiber $/Lot</label>
                          <input
                            type="number"
                            className="form-control"
                            value={formData.fiberPerLot}
                            onChange={(e) => {
                              setFormData({
                                ...formData,
                                fiberPerLot: e.target.value,
                              });
                            }}
                          />{" "}
                          <div style={{ fontSize: "small", color: "red" }}>
                            {errorMessages.fiberPerLot && (
                              <div style={{ fontSize: "small", color: "red" }}>
                                {" "}
                                {errorMessages.fiberPerLot}
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="row ">
                      <div className="col-lg-4">
                        <div className="form-group">
                          <label for="">Fiber Royalty %</label>
                          <input
                            type="number"
                            className="form-control"
                            value={formData.fiberRoyaltyPercent}
                            onChange={(e) => {
                              setFormData({
                                ...formData,
                                fiberRoyaltyPercent: e.target.value,
                              });
                            }}
                          />{" "}
                          <div style={{ fontSize: "small", color: "red" }}>
                            {errorMessages.fiberRoyaltyPercent && (
                              <div style={{ fontSize: "small", color: "red" }}>
                                {" "}
                                {errorMessages.fiberRoyaltyPercent}
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-4">
                        <div className="form-group">
                          <label for="">Buyback</label>
                          <input
                            type="text"
                            className="form-control"
                            value={formData.buyback}
                            onChange={(e) => {
                              setFormData({
                                ...formData,
                                buyback: e.target.value,
                              });
                            }}
                          />{" "}
                          <div style={{ fontSize: "small", color: "red" }}>
                            {errorMessages.buyback && (
                              <div style={{ fontSize: "small", color: "red" }}>
                                {" "}
                                {errorMessages.buyback}
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-4">
                        <div className="form-group">
                          <label for="">Term</label>
                          <input
                            type="number"
                            className="form-control"
                            value={formData.term}
                            onChange={(e) => {
                              setFormData({
                                ...formData,
                                term: e.target.value,
                              });
                            }}
                          />{" "}
                          <div style={{ fontSize: "small", color: "red" }}>
                            {errorMessages.term && (
                              <div style={{ fontSize: "small", color: "red" }}>
                                {" "}
                                {errorMessages.term}
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="row ">
                      <div className="col-lg-4">
                        <div className="form-group">
                          <label for="">Gas Cash Upfront</label>
                          <input
                            type="text"
                            className="form-control"
                            value={formData.gasCashUpfront}
                            onChange={(e) => {
                              setFormData({
                                ...formData,
                                gasCashUpfront: e.target.value,
                              });
                            }}
                          />{" "}
                          <div style={{ fontSize: "small", color: "red" }}>
                            {errorMessages.gasCashUpfront && (
                              <div style={{ fontSize: "small", color: "red" }}>
                                {" "}
                                {errorMessages.gasCashUpfront}
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-4">
                        <div className="form-group">
                          <label for="">Fiber Cash Upfront</label>
                          <input
                            type="text"
                            className="form-control"
                            value={formData.fiberCashUpfront}
                            onChange={(e) => {
                              setFormData({
                                ...formData,
                                fiberCashUpfront: e.target.value,
                              });
                            }}
                          />{" "}
                          <div style={{ fontSize: "small", color: "red" }}>
                            {errorMessages.fiberCashUpfront && (
                              <div style={{ fontSize: "small", color: "red" }}>
                                {" "}
                                {errorMessages.fiberCashUpfront}
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-4">
                        <div className="form-group">
                          <label for="">Cash Upfront Total</label>
                          <input
                            type="number"
                            className="form-control"
                            value={formData.cashUpfrontTotal}
                            onChange={(e) => {
                              setFormData({
                                ...formData,
                                cashUpfrontTotal: e.target.value,
                              });
                            }}
                          />{" "}
                          <div style={{ fontSize: "small", color: "red" }}>
                            {errorMessages.cashUpfrontTotal && (
                              <div style={{ fontSize: "small", color: "red" }}>
                                {" "}
                                {errorMessages.cashUpfrontTotal}
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="row ">
                      <div className="col-lg-4">
                        <div className="form-group">
                          <label for="">Notify</label>
                          <input
                            type="text"
                            className="form-control"
                            value={formData.notify}
                            onChange={(e) => {
                              setFormData({
                                ...formData,
                                notify: e.target.value,
                              });
                            }}
                          />{" "}
                          <div style={{ fontSize: "small", color: "red" }}>
                            {errorMessages.notify && (
                              <div style={{ fontSize: "small", color: "red" }}>
                                {" "}
                                {errorMessages.notify}
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-4">
                        <div className="form-group">
                          <label for="">Status</label>
                          <input
                            type="text"
                            className="form-control"
                            value={formData.status}
                            onChange={(e) => {
                              setFormData({
                                ...formData,
                                status: e.target.value,
                              });
                            }}
                          />{" "}
                          <div style={{ fontSize: "small", color: "red" }}>
                            {errorMessages.status && (
                              <div style={{ fontSize: "small", color: "red" }}>
                                {" "}
                                {errorMessages.status}
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-4">
                        <div className="form-group">
                          <label for="">State</label>
                          <input
                            type="text"
                            className="form-control"
                            value={formData.state}
                            onChange={(e) => {
                              setFormData({
                                ...formData,
                                state: e.target.value,
                              });
                            }}
                          />{" "}
                          <div style={{ fontSize: "small", color: "red" }}>
                            {errorMessages.state && (
                              <div style={{ fontSize: "small", color: "red" }}>
                                {" "}
                                {errorMessages.state}
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="card-footer text-end border-0">
              <div className="row justify-content-center">
                <div className="col-lg-8 text-center">
                  <button
                    className="btn btn-custom startlit_navy"
                    onClick={() => {
                      onClose();
                      clearform();
                    }}
                  >
                    Close
                  </button>{" "}
                  &nbsp;
                  <button
                    className="btn btn-custom electric_cobalt px-5"
                    onClick={(e) => {
                      e.stopPropagation();
                      e.preventDefault();
                      validateAndSubmit();
                    }}
                  >
                    Submit
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddCommunity;
